export const serviciosKeys = {
  all: ['servicios'] as const,
  lists: () => [...serviciosKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...serviciosKeys.lists(), filters] as const,
  // Stats cuelgan de lists() para que invalidar el listado también refresque los KPIs.
  stats: (filters: Record<string, unknown>) =>
    [...serviciosKeys.lists(), 'stats', filters] as const,
  // Vista 360: servicios de un cliente. Cuelga de all() para que las
  // mutations de servicios (create/update/delete) refresquen el tab Servicios.
  porCliente: (idCliente: number) => [...serviciosKeys.all, 'por-cliente', idCliente] as const,
  details: () => [...serviciosKeys.all, 'detail'] as const,
  detail: (id: number) => [...serviciosKeys.details(), id] as const,
};
